import { useEffect, useState } from "react";
import api from "../../services/api";

const useDashboard = (period = "all") => {
  const [data, setData] = useState({
    period: "all",
    totalTickets: 0,
    totalContacts: 0,
    ticketsByStatus: [],
    ticketsByUser: [],
    ticketsByQueue: []
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboard = async () => {
      setLoading(true);

      try {
        const { data } = await api.get("/dashboard", {
          params: { period }
        });

        setData(data);
      } catch (err) {
        console.error("Erro ao carregar dashboard", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [period]);

  return { data, loading };
};

export default useDashboard;
